import { useState } from "react";
import { DOCS_SECTIONS } from "@/data/content";
import PageHero from "@/components/arc/PageHero";
import Reveal from "@/components/arc/Reveal";
import { SimTag } from "@/components/arc/ui";

const Docs = () => {
  const [mobileSection, setMobileSection] = useState(DOCS_SECTIONS[0].id);

  const jump = (id) => {
    setMobileSection(id);
    document.getElementById(`docs-${id}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <PageHero
        index="09"
        eyebrow="DOCS"
        title="PROTOCOL DOCUMENTATION"
        sub="The technical record of the ARCIMUS concept. Where a system is not live, the documentation says so."
      />
      <section className="relative pb-24 md:pb-36">
        <div className="mx-auto max-w-[1600px] px-5 md:px-8">
          <div className="mb-8 lg:hidden">
            <label htmlFor="docs-section-select" className="hud-label mb-3 block">
              JUMP TO SECTION
            </label>
            <select
              id="docs-section-select"
              data-testid="docs-section-select"
              value={mobileSection}
              onChange={(e) => jump(e.target.value)}
              className="w-full border border-ice/20 bg-space px-4 py-3 font-term text-xs tracking-[0.2em] text-chrome focus:border-electric focus:outline-none"
            >
              {DOCS_SECTIONS.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.title}
                </option>
              ))}
            </select>
          </div>

          <div className="grid gap-12 lg:grid-cols-[260px_1fr]">
            <aside className="hidden lg:block">
              <nav className="sticky top-28 border border-ice/10 bg-space/60 p-6" aria-label="Documentation">
                <p className="hud-label mb-5">CONTENTS</p>
                <ul className="space-y-3">
                  {DOCS_SECTIONS.map((s, i) => (
                    <li key={s.id}>
                      <a
                        href={`#docs-${s.id}`}
                        data-testid={`docs-nav-${s.id}`}
                        className="group flex items-baseline gap-3 font-term text-[11px] tracking-[0.18em] text-silver transition-colors duration-300 hover:text-ice"
                      >
                        <span className="text-electric/70">{String(i + 1).padStart(2, "0")}</span>
                        {s.title}
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 border-t border-ice/10 pt-5">
                  <SimTag />
                </div>
              </nav>
            </aside>

            <div className="max-w-3xl space-y-16" data-testid="docs-content">
              {DOCS_SECTIONS.map((section, i) => (
                <Reveal key={section.id} delay={0.03}>
                  <article id={`docs-${section.id}`} className="scroll-mt-28" data-testid={`docs-section-${section.id}`}>
                    <p className="font-term text-[10px] tracking-[0.34em] text-electric">
                      {String(i + 1).padStart(2, "0")} {"//"} ARCIMUS DOCS
                    </p>
                    <h2 className="mt-3 font-display text-2xl font-bold tracking-[0.1em] text-chrome md:text-3xl">
                      {section.title}
                    </h2>
                    <div className="glow-line mt-5 w-24" />
                    <div className="mt-6 space-y-5">
                      {section.body.map((para, j) => (
                        <p key={j} className="text-sm leading-relaxed text-silver md:text-base">
                          {para}
                        </p>
                      ))}
                    </div>
                    {section.code && (
                      <pre className="mt-6 overflow-x-auto border border-ice/15 bg-abyss p-5 font-term text-xs leading-6 text-ice/90">
                        <code>{section.code}</code>
                      </pre>
                    )}
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Docs;
